import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiClient } from '../../apiClient';

const BulkRefundList = () => {
    const [bulkRefunds, setBulkRefunds] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchBulkRefunds = async () => {
        try {
            const response = await apiClient.get('/v1/admin/bulk-refunds');
            if (response.ok) {
                setBulkRefunds(await response.json());
            }
        } catch (error) {
            console.error("Error fetching bulk refunds:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBulkRefunds();
    }, []);

    const getStatusBadge = (status) => {
        const badges = {
            draft: 'bg-gray-100 text-gray-800',
            processing: 'bg-blue-100 text-blue-800 animate-pulse',
            completed: 'bg-green-100 text-green-800',
            failed: 'bg-red-100 text-red-800'
        };
        const labels = {
            draft: '下書き',
            processing: '実行中',
            completed: '完了',
            failed: '失敗あり'
        };
        return (
            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${badges[status] || 'bg-gray-100'}`}>
                {labels[status] || status}
            </span>
        );
    };

    if (loading) return <div className="p-8 text-center">読み込み中...</div>;

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold">一括返金管理</h2>
                <button 
                    onClick={() => navigate('/admin/bulk-refunds/new')}
                    className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
                >
                    一括返金を新規作成
                </button>
            </div>

            <div className="bg-white shadow rounded-lg overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">作成日時</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">障害名</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">障害期間</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase text-center">対象社数</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase text-right">総返金額(税込)</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">ステータス</th>
                            <th className="px-6 py-3"></th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {bulkRefunds.map((refund) => (
                            <tr key={refund.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {new Date(refund.createdAt).toLocaleString()}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    {refund.name}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {new Date(refund.outageStartAt).toLocaleString()} 〜 <br/>
                                    {new Date(refund.outageEndAt).toLocaleString()}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-center">
                                    {refund.refundedCount} / {refund.totalTargetCount}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-right font-bold">
                                    {refund.totalRefundAmount.toLocaleString()}円
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {getStatusBadge(refund.status)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <Link to={`/admin/bulk-refunds/${refund.id}`} className="text-indigo-600 hover:text-indigo-900">詳細</Link>
                                </td>
                            </tr>
                        ))}
                        {bulkRefunds.length === 0 && (
                            <tr>
                                <td colSpan="7" className="px-6 py-10 text-center text-gray-500">履歴はありません。</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BulkRefundList;
